'use client'

import { useCallback } from 'react'

/**
 * WCAG 2.4.1 skip-link. Hidden until Tab-focused. Imperative-focuses the
 * first <main> element on the page (falls back to #main-content wrapper).
 * That way activation jumps past the nav into the actual page content
 * regardless of which page is rendered.
 */
export default function SkipLink() {
  const handleClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    const target =
      (document.querySelector('main') as HTMLElement | null) ||
      (document.getElementById('main-content') as HTMLElement | null)
    if (!target) return
    const hadTabIndex = target.hasAttribute('tabindex')
    if (!hadTabIndex) target.setAttribute('tabindex', '-1')
    target.focus({ preventScroll: false })
    target.scrollIntoView({ block: 'start', behavior: 'auto' })
    if (!hadTabIndex) {
      const onBlur = () => {
        target.removeAttribute('tabindex')
        target.removeEventListener('blur', onBlur)
      }
      target.addEventListener('blur', onBlur)
    }
  }, [])

  return (
    <a href="#main-content" className="skip-link" onClick={handleClick}>
      Skip to main content
    </a>
  )
}
